import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import EditModal from "../EditModal";
import { deleteUnit, getfloorData } from "../../store/actions/floorActions";
import Select from "../DropDownSelect";

const optionData = [
  {
    label: "Parking",
    value: 0,
  },
  {
    label: "Floor 5",
    value: 5,
  },
  {
    label: "Floor 6",
    value: 6,
  },
  {
    label: "Floor 7",
    value: 7,
  },
  {
    label: "Floor 8",
    value: 8,
  },
  {
    label: "Floor 9",
    value: 9,
  },
  {
    label: "Floor 10",
    value: 10,
  },
  {
    label: "Floor 11",
    value: 11,
  },
  {
    label: "Floor 12",
    value: 12,
  },
  {
    label: "Floor 14",
    value: 14,
  },
  {
    label: "Floor 15",
    value: 15,
  },
  {
    label: "Floor 16",
    value: 16,
  },
];

export default function TableOne() {
  const [isOpen, setisOpen] = useState(false);
  const [label, setlabel] = useState("");
  const [unitNumber, setunitNumber] = useState(null);
  const [floorNumber, setfloorNumber] = useState(5);
  const packageData = useSelector((state) => state.floor.list);
  const dispatch = useDispatch();

  useEffect(() => {
    if (floorNumber !== null && floorNumber !== undefined) {
      dispatch(getfloorData(floorNumber));
    }
  }, [floorNumber, dispatch]);

  const handleFloorChange = (selectedFloor) => {
    setfloorNumber(selectedFloor);
  };

  const addUnitData = () => {
    setisOpen(!isOpen);
    setlabel("Add Unit");
  };

  return (
    <div className="w-full max-w-[1200px] mx-auto">
      <div className="max-w-full">
        <div className="flex items-start mb-6">
          <Select
            options={optionData}
            value={floorNumber}
            onChange={handleFloorChange}
          />
        </div>
        <table className="w-full border-collapse">
          <thead>
            <tr className="border-b-2 border-black">
              <th className="py-4 px-4 text-left font-medium text-black">
                Unit Number
              </th>
              <th className="py-4 px-4 text-left font-medium text-black">
                Gross SQFT
              </th>
              <th className="py-4 px-4 text-left font-medium text-black">
                Terrace SQFT
              </th>
              <th className="py-4 px-4 text-left font-medium text-black">
                Common Charge
              </th>
              <th className="py-4 px-4 text-left font-medium text-black">
                Status
              </th>
              <th className="py-4 px-4 text-center font-medium text-black">
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            {packageData && packageData.length > 0 ? (
              packageData.map((packageItem, key) => (
                <tr key={key} className="border-b border-gray-300">
                  <td className="pt-4 pb-2 px-4">
                    <p className="text-black">{packageItem.unitNumber}</p>
                  </td>
                  <td className="pt-4 pb-2 px-4">
                    <p className="text-black">{packageItem.SQFT}</p>
                  </td>
                  <td className="pt-4 pb-2 px-4">
                    <p className="text-black">
                      {packageItem.terraceSQFT || "0"}
                    </p>
                  </td>
                  <td className="pt-4 pb-2 px-4">
                    <p className="text-black">
                      {packageItem.common_charge || "-"}
                    </p>
                  </td>
                  <td className="pt-4 pb-2 px-4">
                    <p
                      className={`text-md font-medium ${
                        packageItem.Status === "Available"
                          ? "text-[#10b981]"
                          : "text-[#ef4444]"
                      }`}
                    >
                      {packageItem.Status}
                    </p>
                  </td>
                  <td className="pt-4 pb-2 px-4">
                    <div className="flex items-center justify-center space-x-3.5">
                      <button
                        onClick={() => {
                          const floorNum = packageItem.floorNumber;
                          const unitNum = packageItem.unitNumber;
                          dispatch(deleteUnit({ floorNum, unitNum }))
                            .then(() => {
                              console.log("deleted successfully");
                              dispatch(getfloorData(floorNum));
                            })
                            .catch((error) => {
                              console.log(error);
                            });
                        }}
                        className="hover:text-primary"
                      >
                        <svg
                          className="fill-current"
                          width="18"
                          height="18"
                          viewBox="0 0 18 18"
                          fill="black"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M13.7535 2.47502H11.5879V1.9969C11.5879 1.15315 10.9129 0.478149 10.0691 0.478149H7.90352C7.05977 0.478149 6.38477 1.15315 6.38477 1.9969V2.47502H4.21914C3.40352 2.47502 2.72852 3.15002 2.72852 3.96565V4.8094C2.72852 5.42815 3.09414 5.9344 3.62852 6.1594L4.07852 15.4688C4.13477 16.6219 5.09102 17.5219 6.24414 17.5219H11.7004C12.8535 17.5219 13.8098 16.6219 13.866 15.4688L14.3441 6.13127C14.8785 5.90627 15.2441 5.3719 15.2441 4.78127V3.93752C15.2441 3.15002 14.5691 2.47502 13.7535 2.47502ZM7.67852 1.9969C7.67852 1.85627 7.79102 1.74377 7.93164 1.74377H10.0973C10.2379 1.74377 10.3504 1.85627 10.3504 1.9969V2.47502H7.70664V1.9969H7.67852ZM4.02227 3.96565C4.02227 3.85315 4.10664 3.74065 4.24727 3.74065H13.7535C13.866 3.74065 13.9785 3.82502 13.9785 3.96565V4.8094C13.9785 4.9219 13.8941 5.0344 13.7535 5.0344H4.24727C4.13477 5.0344 4.02227 4.95002 4.02227 4.8094V3.96565ZM11.7285 16.2563H6.27227C5.79414 16.2563 5.40039 15.8906 5.37227 15.3844L4.95039 6.2719H13.0785L12.6566 15.3844C12.6004 15.8625 12.2066 16.2563 11.7285 16.2563Z" />
                        </svg>
                      </button>
                      <button
                        className="hover:text-primary"
                        onClick={() => {
                          setisOpen(!isOpen);
                          setlabel("Edit Unit");
                          setfloorNumber(packageItem.floorNumber);
                          setunitNumber(packageItem.unitNumber);
                        }}
                      >
                        <svg
                          className="fill-current"
                          width="18"
                          height="18"
                          viewBox="0 0 24 24"
                          fill="black"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M20.71,7.04C21.1,6.65 21.1,6 20.71,5.63L18.37,3.29C18,2.9 17.35,2.9 16.96,3.29L15.12,5.12L18.87,8.87M3,17.25V21H6.75L17.81,9.93L14.06,6.18L3,17.25Z" />
                        </svg>
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6" className="text-center py-8 text-[#333f48]">
                  No units available for this floor
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <div className="flex justify-center mt-8 mb-20">
        <button
          onClick={addUnitData}
          className="inline-flex items-center justify-center rounded-md bg-[#ad885d] py-3 px-8 text-center font-medium text-white hover:bg-opacity-90"
        >
          Add Unit
        </button>
      </div>
      <EditModal
        Open={isOpen}
        label={label}
        floorNumber={floorNumber}
        unitNumber={unitNumber}
      />
    </div>
  );
}
